import { api } from "./client";
import { toast } from "react-toastify";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Fetch low stock items
export const fetchStockList = async () => {
  try {
    const response = await api.get(`${BASE_URL}api/low-stock/stock-list`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return {
      success: true,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Failed to fetch stock list:", error);
    toast.error(
      error.response?.data?.message || `${window.translate("Failed to fetch stock list.")}`
    );
    return {
      success: false,
      data: [],
      message: error.response?.data?.message || "Fetch failed.",
    };
  }
};

// Update low stock item
export const updateLowStock = async (id, payload) => {
  try {
    const response = await api.put(
      `${BASE_URL}api/low-stock/${id}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    //  toast.success(window.translate("Low stock updated successfully"));
    return response.data;
  } catch (error) {
    toast.error(
      error.response?.data?.message || `${window.translate("Failed to update low stock.")}`
    );
    throw error;
  }
};

// export const deleteLowStockItem = async (id, source) => {
//   try {
//     const response = await api.delete(`${BASE_URL}api/low-stock/${id}`, {
//       data: { source }, // api allows sending request body for DELETE via `data`
//       headers: {
//         "Content-Type": "application/json",
//         "Accept-Language": "en", // or 'ar', dynamically if needed
//       },
//     });

//     return {
//       success: true,
//       message: response.data.message,
//       deletedId: response.data.deletedId,
//     };
//   } catch (error) {
//     console.error("❌ deleteLowStockItem error:", error);
//     return {
//       success: false,
//       message:
//         error.response?.data?.message || `${window.translate("Failed to delete low stock item.")}`,
//     };
//   }
// };

export const deleteLowStockItem = async (id, source) => {
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
  const token = localStorage.getItem("token");

  const res = await api.delete(`${BASE_URL}api/low-stock/${id}`, {
    data: { source },
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": lang,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  // assuming backend sends: { success: true, message: "Item moved to Out of Stock successfully." }
  return res.data;
};